module.exports = __webpack_public_path__ + "static/media/bytt-no-3.334fb02c.mp3";